
import { routes_names, layout_names } from '../constants'
// layouts
import AuthLayout from '@/layouts/Auth.vue'
import DashboardLayout from '@/layouts/Dashboard.vue'
import PublicLayout from '@/layouts/Public.vue'

export const routes = [
  {
    path: '/',
    name: layout_names.authorization,
    component: AuthLayout,
    redirect: {
      name: routes_names.login
    },
    children: [
      {
        path: '/login',
        name: routes_names.login,
        component: () => import('@/views/auth/Login.vue'),
        meta: {
          title: 'Login',
        },
      }
    ],
    meta: {
      notRequiresAuth: true,
    },
  },
  {
    path: '/',
    name: layout_names.dashboard,
    component: DashboardLayout,
    redirect: {
      name: routes_names.main
    },
    children: [
      {
        path: '/dashboard',
        name: routes_names.main,
        component: () => import('@/views/app/index.vue'),
        meta: {
          title: 'Dashboard',
        },
      },
      {
        path: '/filters',
        name: routes_names.filters,
        component: () => import('@/views/app/Filters.vue'),
        meta: {
          title: 'Filters',
        },
      },
      {
        path: '/thresholds',
        name: routes_names.thresholds,
        component: () => import('@/views/app/Thresholds.vue'),
        meta: {
          title: 'Thresholds',
        },
      },
      {
        path: '/sip-servers',
        name: routes_names.sip_servers,
        component: () => import('@/views/app/SipServers.vue'),
        meta: {
          title: 'Sip Servers',
        },
      },
      {
        path: '/call-hangup-reports',
        name: routes_names.call_hangup_reports,
        component: () => import('@/views/app/CallHangupReports.vue'),
        meta: {
          title: 'Call Hangup Reports',
        },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    name: layout_names.public,
    component: PublicLayout,
    redirect: {
      name: routes_names.call_fail
    },
    children: [
      {
        path: '/call-fail',
        name: routes_names.call_fail,
        component: () => import('@/views/public/CallFail.vue'),
        meta: {
          title: 'Call Fail',
        },
      },
      {
        path: '/check-fail',
        name: routes_names.check_fail,
        component: () => import('@/views/public/CheckFail.vue'),
        meta: {
          title: 'Check Fail',
        },
      },
      {
        path: '/check-redis-fail',
        name: routes_names.check_redis_fail,
        component: () => import('@/views/public/CheckRedisFail.vue'),
        meta: {
          title: 'Check Redis Fail',
        },
      },
    ],
  },
]